import { IPIRANGA_PROMOTION_AVAILABLE, IPIRANGA_PROMOTION_RESET } from '../actionTypes/ipirangaPromotion'

const INITIAL_STATE = {
  available: false,
  // distingue "ainda não perguntei ao back" de "back respondeu false" —
  // usado pelo boot gate do defaultLayout
  resolved: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IPIRANGA_PROMOTION_AVAILABLE:
      return { ...state, available: action.payload === true, resolved: true }
    // REV-1986: backoffice troca de posto no busca-parceiro — volta ao estado
    // "ainda não perguntei" para o boot gate segurar até o /available do novo posto
    case IPIRANGA_PROMOTION_RESET:
      return INITIAL_STATE
    default:
      return state
  }
}
